/**
 * ToastModal component.
 */
import Toast from '@components/elements/toast/toast';
import { DELAY, DURATION } from '@shared/types/constants/animations';
import { clearModal, modalSelector } from '@shared/store/slices/modal.slice';
import { useAppDispatch, useAppSelector } from '@shared/store/hooks';
import { useEffect } from 'react';

/**
 * Displays a self-dismissing toast message. Clears itself from the modal
 * stack once the fade-out animation finishes.
 */
export default function ToastModal() {
  const dispatch = useAppDispatch();
  const { params } = useAppSelector(modalSelector);

  useEffect(() => {
    const timer = setTimeout(
      () => dispatch(clearModal()),
      DELAY.TOAST_AUTO_CLOSE + DURATION.OPACITY_TRANSITION
    );
    return () => clearTimeout(timer);
  }, []);

  return <Toast message={(params.message || '') as string} />;
}
